// api
import createNewTicketAPICall from './api/crateNewTicket';
import getTicketDetailApiCall from './api/getTicketDetail';
import updateTicketDetailApiCall from './api/updateTicketDetail';
import cancelTicketApiCall from './api/cancelTicket';
import moveTicketToTMSApiCall from './api/moveTicketToTMS';
import sendTicketUpdateApiCall from './api/sendTicketUpdate';
import launchOfferApiCall from './api/launchOffer';
import finishCostNegotiationApiCall from './api/finishCostNegotiation';
import closeAuctionsApiCall from './api/closeAuctions';
import addBidApiCall from './api/addBid';
import createCommentApiCall from './api/createComment';
// utils
import { diff, updatedDiff } from 'deep-object-diff';
import moment from 'moment';
// settings
import ticketFormDefaultValues from './components/ticketForm/config/ticketFormDefaultValues';
import { STATES } from './constants';
import ADDITIONAL_SERVICES from './constants/additionalServices';
import ticketActions from './constants/ticketActions';

//
//
//
//
//
//
// defaultValues
//
//
//
//
//
//
//

const getDefaultInitialFormValues = () => deepCopy(ticketFormDefaultValues);

const getDefaultLoad = () => {
  return {
    number_of_items: 1,
    load_type: 'eupallet',
    item_length: '',
    item_width: '',
    item_height: '',
  };
};

const defaultValues = {
  getDefaultInitialFormValues,
  getDefaultLoad,
};

//
//
//
//
//
//
// utils
//
//
//
//
//
//
//

const deepCopy = (object) => JSON.parse(JSON.stringify(object));

const navigateToList = async ({ history }) => {
  history.push('/emergencies/');
};

const getFormatedId = (id) => {
  const numberOfWantedDigits = 4;
  const numberOfActualDigits = id.toString().length;
  const amountOfMissingDigits = numberOfWantedDigits - numberOfActualDigits;
  let formatedId = '';
  for (let i = 0; i < amountOfMissingDigits; i++) formatedId = formatedId + '0';
  formatedId = formatedId + id;
  return formatedId;
};

const clearPropsForInput = (props) => {
  const cleanPropsForInput = { ...props };
  delete cleanPropsForInput.hasError;
  delete cleanPropsForInput.isSubmitting;
  delete cleanPropsForInput.isValid;
  delete cleanPropsForInput.resetForm;
  delete cleanPropsForInput.submitForm;
  delete cleanPropsForInput.validateForm;
  delete cleanPropsForInput.setError;
  delete cleanPropsForInput.setFieldError;
  delete cleanPropsForInput.setFieldTouched;
  delete cleanPropsForInput.setFieldValue;
  delete cleanPropsForInput.setStatus;
  delete cleanPropsForInput.setSubmitting;
  delete cleanPropsForInput.setTouched;
  delete cleanPropsForInput.setValues;
  delete cleanPropsForInput.setFormikState;
  delete cleanPropsForInput.initialValues;
  delete cleanPropsForInput.handleBlur;
  delete cleanPropsForInput.handleChange;
  delete cleanPropsForInput.handleReset;
  delete cleanPropsForInput.handleSubmit;
  delete cleanPropsForInput.validateOnChange;
  delete cleanPropsForInput.validateOnBlur;
  delete cleanPropsForInput.showErrors;
  delete cleanPropsForInput.customHasError;
  delete cleanPropsForInput.isRequired;
  delete cleanPropsForInput.customHasError;
  delete cleanPropsForInput.isDisabled;
  delete cleanPropsForInput.setErrors;
  delete cleanPropsForInput.customErrorFieldName;
  return cleanPropsForInput;
};

const mapCountryCodeToCountryName = (countryCode) => {
  switch (countryCode) {
    case 'ES':
      return 'Spain';
    case 'PT':
      return 'Portugal';
    case 'FR':
      return 'France';
    case 'IT':
      return 'Italy';
    case 'DE':
      return 'Germany';
    case 'GB':
      return 'United Kingdom';
    case 'BE':
      return 'Belgium';
    case 'NL':
      return 'Netherlands';
    case 'LU':
      return 'Luxembourg';
    case 'IE':
      return 'Ireland';
    case 'DK':
      return 'Denmark';
    case 'SE':
      return 'Sweden';
    case 'FI':
      return 'Finland';
    case 'NO':
      return 'Norway';
    case 'PL':
      return 'Poland';
    case 'CZ':
      return 'Czech Republic';
    case 'SK':
      return 'Slovakia';
    case 'HU':
      return 'Hungary';
    case 'AT':
      return 'Austria';
    case 'SI':
      return 'Slovenia';
    case 'HR':
      return 'Croatia';
    case 'BA':
      return 'Bosnia and Herzegovina';
    case 'RS':
      return 'Serbia';
    case 'ME':
      return 'Montenegro';
    case 'AL':
      return 'Albania';
    case 'MK':
      return 'North Macedonia';
    case 'GR':
      return 'Greece';
    case 'BG':
      return 'Bulgaria';
    case 'RO':
      return 'Romania';
    case 'MD':
      return 'Moldova';
    case 'UA':
      return 'Ukraine';
    case 'BY':
      return 'Belarus';
    case 'LT':
      return 'Lithuania';
    case 'LV':
      return 'Latvia';
    case 'EE':
      return 'Estonia';
    default:
      return countryCode;
  }
};

const utils = {
  deepCopy,
  navigateToList,
  getFormatedId,
  clearPropsForInput,
  mapCountryCodeToCountryName,
};

//
//
//
//
//
//
// business
//
//
//
//
//
//
//

const colorStates = {
  [STATES.REJECTED]: '#CC000A',
  [STATES.PENDING]: '#2396DC',
  [STATES.QUOTE_SENT]: '#94A6B8',
  [STATES.EXPIRED]: '#FF6400',
  [STATES.ACCEPTED]: '#0FB44B',
  [STATES.CANCELLED]: '#CCD6E0',
  [STATES.DONE]: '#00FF00',
  [STATES.OUT_OF_SCOPE]: '#CCD6E0',
  [STATES.DRAFT]: '#eeb93f',
};

const getTicketColor = (ticket) => {
  return colorStates[ticket.synthetic_state];
};

const canTicketBeEdited = (ticket) => {
  if (!!!ticket) return false;
  const state = ticket.synthetic_state;
  const statesThatCanEdit = [
    STATES.DRAFT,
    STATES.PENDING,
    STATES.QUOTE_SENT,
    STATES.REJECTED,
    STATES.EXPIRED,
  ];
  return statesThatCanEdit.includes(state);
};

const canTicketBeCancelled = (ticket) => {
  if (!!!ticket) return false;
  const state = ticket.synthetic_state;
  const statesThatCanCancel = [
    STATES.DRAFT,
    STATES.PENDING,
    STATES.QUOTE_SENT,
    STATES.REJECTED,
    STATES.ACCEPTED,
    STATES.DONE,
  ];
  return statesThatCanCancel.includes(state);
};

// ticket has deadline warning if the deadline is less than x minutes from now
const hasDeadlineWarning = (ticket) => {
  // check if state can have warning (we dont want to show warnings for cancelled tickets)
  const statesThatCanHaveDeadlineWarning = [STATES.PENDING, STATES.REJECTED, STATES.EXPIRED];
  const canHaveDeadlineWarning = statesThatCanHaveDeadlineWarning.includes(ticket.synthetic_state);
  if (!canHaveDeadlineWarning) return false;
  //   check if customer did set a deadline
  const deadline = ticket.order_data.complementary_info.customer_deadline;
  const hasDeadline =
    deadline !== '' &&
    deadline !== null &&
    typeof deadline !== 'undefined' &&
    moment(deadline).isValid();
  if (!hasDeadline) return false;
  // see if now, is after deadline - x minutes
  // minutesForWarning is 60
  // deadline is 14:40
  // fromDate, now, is 13:50,
  // toDate, deadline - minutesForWarning, is 13:30
  // if fromDate is after toDate, show we have warning
  const minutesForWarning = 60;
  const toDate = moment(deadline).subtract(minutesForWarning, 'minutes');
  const now = moment();
  const fromDate = now;
  return fromDate.isAfter(toDate, 'minutes');
};

const canTicketReceiveUpdate = (ticket, type) => {
  if (
    [
      ticketActions.ON_THE_WAY,
      ticketActions.DELAYED,
      ticketActions.DELIVERED,
      ticketActions.PICKUP,
    ].indexOf(type) > -1
  ) {
    return ticket.synthetic_state === STATES.DONE;
  }
  return true;
};

const isQuoteValid = (ticket) => {
  //states with invalid quotes
  if (
    [STATES.CANCELLED, STATES.EXPIRED, STATES.OUT_OF_SCOPE, STATES.REJECTED].includes(
      ticket.synthetic_state
    )
  ) {
    return false;
  }
  return true;
};

const isCreateQuoteVisible = (ticket) => {
  if (
    [STATES.DRAFT, STATES.PENDING, STATES.REJECTED, STATES.EXPIRED].includes(ticket.synthetic_state)
  ) {
    return true;
  }
  return false;
};

const isCreateQuoteEnabled = (ticket) => {
  const hasAgent = !!ticket?.assigned_to?.id;
  const isDraft = ticket.synthetic_state === STATES.DRAFT;
  return hasAgent && !isDraft;
};

const ticketHasOpenAuctions = (ticket) => {
  const routes = ticket?.cargo?.routes || [];
  return routes.some((route) => {
    const auctions = route?.auctions || [];
    return auctions.some((auction) => auction.open);
  });
};

const numberOfBidsInOpenAuctions = (ticket) => {
  const routes = ticket?.cargo?.routes || [];
  return routes.reduce((totalNumberOfBids, route) => {
    const auctions = route?.auctions || [];
    return auctions.reduce((accumulatedBidsInAuction, auction) => {
      return auction.open
        ? auction.bids.length + accumulatedBidsInAuction
        : accumulatedBidsInAuction;
    }, totalNumberOfBids);
  }, 0);
};

const hasCargo = (ticket) => {
  return !!ticket?.cargo;
};

const getBids = (ticket) => {
  const routes = ticket?.cargo?.routes || [];
  const bids = routes.reduce(
    (c, v) =>
      c.concat(
        (v?.auctions || [])
          .filter((auction) => auction.open)
          .reduce((c, v) => c.concat(v?.bids || []), [])
      ),
    []
  );
  return bids;
};
const numberOfBids = (ticket) => {
  const bids = getBids(ticket);
  return bids.length;
};

const minMaxNormalisation = (values, start, end) => {
  const max = Math.max(...values);
  const min = Math.min(...values);

  if (max === min) {
    return new Array(values.length).fill(0);
  }

  return values.map((value) => start + ((value - min) * (end - start)) / (max - min));
};

const reversedMinMaxNormalisation = (values, start, end) => {
  return minMaxNormalisation(values, start, end).map((value) => end - value + start);
};

const getSuggestedBid = (bids) => {
  if (bids.length === 0) return null;

  const normalisedAmounts = reversedMinMaxNormalisation(
    bids.map((bid) => bid.cost.amount),
    1,
    2
  );
  const normalisedRating = minMaxNormalisation(
    bids.map((bid) => bid.bidder?.carrier?.rating || 0),
    1,
    2
  );
  const results = bids.map((bid, index) => {
    return {
      bid,
      result: normalisedAmounts[index] + normalisedRating[index],
    };
  });
  return results.reduce((curr, acc) => {
    return parseFloat(curr.result) < parseFloat(acc.result) ? acc : curr;
  }, results[0]).bid;
};

const showLaunchOffer = (ticket) => {
  // show launch offer action (disabled or not)
  // when the ticket has routes and no open auctions and is not resolved
  const routes = ticket?.cargo?.routes || [];
  const hasRoutes = routes.length > 0;
  const hasOpenAuctions = routes.some((route) => {
    const auctions = route?.auctions || [];
    return auctions.some((auction) => auction.open);
  });
  const isCargoResolved = !!ticket?.cargo?.resolved;
  return hasRoutes && !hasOpenAuctions && !isCargoResolved;
};

const canLaunchOffer = (ticket) => {
  // launch offer action is enabled
  // when the ticket has an assigned agent, has the right state, has routes and no open auctions
  const hasAgent = !!ticket?.assigned_to?.id;
  const statesThatCanLaunchOffer = [STATES.PENDING, STATES.QUOTE_SENT, STATES.REJECTED];
  const hasRightState = statesThatCanLaunchOffer.includes(ticket.synthetic_state);

  const routes = ticket?.cargo?.routes || [];
  const hasRoutes = routes.length > 0;

  const hasOpenAuctions = routes.some((route) => {
    const auctions = route?.auctions || [];
    return auctions.some((auction) => auction.open);
  });

  const canLaunchOffer = hasAgent && hasRightState && hasRoutes && !hasOpenAuctions;
  return canLaunchOffer;
};

const showFinishCostNegotiation = (ticket) => {
  // show finish cost negotiation action (disabled or not)
  // when the ticket has routes, open auctions,
  // quote is not rejected and quote is not expired
  const routes = ticket?.cargo?.routes || [];
  const hasRoutes = routes.length > 0;
  const quoteIsNotRejected = ticket.synthetic_state !== STATES.REJECTED;
  const quoteIsNotExpired = ticket.synthetic_state !== STATES.EXPIRED;
  const hasOpenAuctions = routes.some((route) => {
    const auctions = route?.auctions || [];
    return auctions.some((auction) => auction.open);
  });
  return hasRoutes && hasOpenAuctions && quoteIsNotRejected && quoteIsNotExpired;
};

const canFinishCostNegotiation = (ticket) => {
  // can finish cost negotiation action is enabled
  // when the ticket has a quote, has open auctions
  const hasQuote = !!ticket.quote;

  const routes = ticket?.cargo?.routes || [];

  const hasOpenAuctions = routes.some((route) => {
    const auctions = route?.auctions || [];
    return auctions.some((auction) => auction.open);
  });

  return hasQuote && hasOpenAuctions;
};

const showCloseAuctions = (ticket) => {
  const routes = ticket?.cargo?.routes || [];
  const hasRoutes = routes.length > 0;
  const hasOpenAuctions = routes.some((route) => {
    const auctions = route?.auctions || [];
    return auctions.some((auction) => auction.open);
  });
  return hasRoutes && hasOpenAuctions;
};

const canCloseAuctions = (ticket) => {
  const routes = ticket?.cargo?.routes || [];
  const hasRoutes = routes.length > 0;
  const hasOpenAuctions = routes.some((route) => {
    const auctions = route?.auctions || [];
    return auctions.some((auction) => auction.open);
  });
  return hasRoutes && hasOpenAuctions;
};

const hasOpenAuctionsWithBids = (ticket) => {
  const routes = ticket?.cargo?.routes || [];
  return routes.some((route) => {
    const auctions = route?.auctions || [];
    return auctions.some((auction) => auction.open && auction.bids.length > 0);
  });
};

const isTicketCancelled = (ticket) => {
  return ticket.synthetic_state === STATES.CANCELLED;
};

const getFirstOpenAuction = (ticket) => {
  const routes = ticket?.cargo?.routes || [];

  for (let route of routes) {
    const auctions = route?.auctions || [];
    const openAuction = auctions.find((auction) => auction.open);

    if (openAuction) {
      return openAuction;
    }
  }

  return null;
};

function compareLoadsData(newValues, originalTicket) {
  const newLoads = newValues.order_data.loads_data.loads;
  const originalLoads = originalTicket.order_data.loads_data.loads;

  const changes = newLoads.map((newLoad, index) => {
    const originalLoad = originalLoads[index];

    return Object.keys(newLoad).reduce((acc, key) => {
      if (newLoad[key] !== originalLoad[key]) {
        acc[key] = {
          previous: originalLoad[key],
          current: newLoad[key],
        };
      }

      return acc;
    }, {});
  });

  return changes;
}

function getTicketChanges(originalTicket, newValues) {
  // Check for changes in vehicle_details before diffUpdated
  let vehicleDetailsChanged = false;
  if (
    originalTicket.order_data &&
    originalTicket.order_data.service_type &&
    originalTicket.order_data.service_type.vehicle_details &&
    newValues.order_data &&
    newValues.order_data.service_type &&
    newValues.order_data.service_type.vehicle_details &&
    JSON.stringify(originalTicket.order_data.service_type.vehicle_details) !==
      JSON.stringify(newValues.order_data.service_type.vehicle_details)
  ) {
    vehicleDetailsChanged = true;
  }

  const diffUpdated = updatedDiff(originalTicket, newValues);
  const diffWithChanges = {};

  // If vehicleDetailsChanged is true, add it to diffWithChanges
  if (vehicleDetailsChanged) {
    diffWithChanges['vehicle_details'] = {
      previous: originalTicket.order_data.service_type.vehicle_details,
      current: newValues.order_data.service_type.vehicle_details,
    };
  }

  try {
    // Check for changes in loads_data
    if (
      originalTicket.order_data &&
      originalTicket.order_data.loads_data &&
      newValues.order_data &&
      newValues.order_data.loads_data
    ) {
      const loadsChanges = compareLoadsData(newValues, originalTicket);
      if (loadsChanges.length > 0) {
        diffWithChanges['loads_data'] = loadsChanges;
      }
    }
  } catch (e) {}

  for (const key in diffUpdated) {
    if (typeof diffUpdated[key] === 'object' && diffUpdated[key] !== null) {
      diffWithChanges[key] = {};
      for (const subKey in diffUpdated[key]) {
        if (
          originalTicket[key] &&
          newValues[key] &&
          originalTicket[key][subKey] !== undefined &&
          newValues[key][subKey] !== undefined
        ) {
          diffWithChanges[key][subKey] = {
            previous: originalTicket[key][subKey],
            current: newValues[key][subKey],
          };
        }
      }
    } else {
      diffWithChanges[key] = {
        previous: originalTicket[key],
        current: newValues[key],
      };
    }
  }

  return diffWithChanges;
}

const hasQuoteSent = (ticket) => {
  return ticket.synthetic_state === STATES.QUOTE_SENT;
};

const bussiness = {
  canTicketBeEdited,
  canTicketBeCancelled,
  getTicketColor,
  colorStates,
  hasDeadlineWarning,
  canTicketReceiveUpdate,
  isQuoteValid,
  isCreateQuoteVisible,
  isCreateQuoteEnabled,
  numberOfBids,
  getBids,
  showLaunchOffer,
  canLaunchOffer,
  showFinishCostNegotiation,
  canFinishCostNegotiation,
  showCloseAuctions,
  canCloseAuctions,
  hasOpenAuctionsWithBids,
  numberOfBidsInOpenAuctions,
  ticketHasOpenAuctions,
  hasCargo,
  isTicketCancelled,
  getFirstOpenAuction,
  getSuggestedBid,
  getTicketChanges,
  hasQuoteSent,
};

//
//
//
//
//
//
// data transformation
//
//
//
//
//
//
//

const cleanTimeFromBackend = (time) => {
  if (time.length === 8) {
    time = time.slice(0, 5);
  }
  return time;
};

const cleanNullableNumberForBackend = (numberInStringFormat) => {
  if (!numberInStringFormat) return null;
  if (numberInStringFormat === '') return null;
  return parseFloat(numberInStringFormat) || null;
};

const prepareTimeForBackend = (time) => {
  if (time.length === 5) return `${time}:00`;
  return time;
};

const getDatetimeFromSeparateDateAndTime = ({ date, time }) => {
  if (time === '' || date === '') return '';
  const timeParts = time.split(':');
  const hours = timeParts[0];
  const minutes = timeParts[1];
  const dateTime = moment(date).hours(hours).minutes(minutes);
  const dateTimeInIsoFormat = dateTime.toISOString();
  return dateTimeInIsoFormat;
};

const getSeparateDateAndTimeFromDatetime = ({ dateTime }) => {
  if (!dateTime || dateTime === '')
    return {
      date: '',
      time: '',
    };
  const dateTimeMoment = moment(dateTime).local();
  const date = dateTimeMoment.format('YYYY-MM-DD');
  const time = dateTimeMoment.format('HH:mm');
  return {
    date,
    time,
  };
};

const getTicketDtoFromFormValues = ({ values }) => {
  const dto = { ...values };

  //   set notification_transports
  if (values.custom.transport.selected_notification_transport === 'whatsapp') {
    dto.shipper_data.notification_transports = [
      {
        transport: 'whatsapp',
        phone_number: values.custom.transport.phone,
      },
    ];
  }
  if (values.custom.transport.selected_notification_transport === 'email') {
    dto.shipper_data.notification_transports = [
      {
        transport: 'email',
        email: values.custom.transport.email,
      },
    ];
  }
  //   delete dto.custom.transport;
  //   set times
  dto.order_data.pickup.time_from = prepareTimeForBackend(dto.order_data.pickup.time_from);
  dto.order_data.pickup.time_to = prepareTimeForBackend(dto.order_data.pickup.time_to);
  dto.order_data.dropoff.time_from = prepareTimeForBackend(dto.order_data.dropoff.time_from);
  dto.order_data.dropoff.time_to = prepareTimeForBackend(dto.order_data.dropoff.time_to);
  //   set load list
  dto.order_data.loads_data.loads = dto.order_data.loads_data.loads.map((load) => ({
    ...load,
    item_height: cleanNullableNumberForBackend(load.item_height),
    item_length: cleanNullableNumberForBackend(load.item_length),
    item_width: cleanNullableNumberForBackend(load.item_width),
  }));
  //   set loads total
  const totals = dto.order_data.loads_data.totals;
  dto.order_data.loads_data.cubic_meters = cleanNullableNumberForBackend(totals.cubic_meters);
  dto.order_data.loads_data.linear_meters = cleanNullableNumberForBackend(totals.linear_meters);
  dto.order_data.loads_data.total_weight = cleanNullableNumberForBackend(totals.total_weight);
  //  deadline
  const deadlineDate = dto.order_data.complementary_info.customer_deadline_date;
  const deadlineTime = dto.order_data.complementary_info.customer_deadline_time;
  const deadline = getDatetimeFromSeparateDateAndTime({ date: deadlineDate, time: deadlineTime });
  dto.order_data.complementary_info.customer_deadline = deadline;
  if (deadline === '') dto.order_data.complementary_info.customer_deadline = null;

  const otherAdditionalServices = dto.order_data.complementary_info.other_additional_services;

  !!otherAdditionalServices &&
    dto.order_data.complementary_info.additional_services.push(otherAdditionalServices);

  if (dto.shipper_id === '') delete dto.shipper_id;

  return dto;
};

const convertNullToEmptyString = (value) => {
  if (value === 0) return null;
  return value;
};

const knownAdditionalServices = ADDITIONAL_SERVICES.map((service) => service.value);

const splitAdditionalServices = (additionalServices) => {
  const known = additionalServices.filter((service) => knownAdditionalServices.includes(service));
  const unknown = additionalServices.filter(
    (service) => !knownAdditionalServices.includes(service)
  );

  return [known, unknown.join('\n')];
};

const getInitialFormValuesFromTicketDto = ({ ticketDto }) => {
  let initialValues = getDefaultInitialFormValues();
  const copyTicketDto = deepCopy(ticketDto);

  // fill shipper data
  initialValues.shipper_data = copyTicketDto.shipper_data;

  if (!!copyTicketDto.shipper_data.notification_transports[0]) {
    if (copyTicketDto.shipper_data.notification_transports[0].transport === 'whatsapp') {
      initialValues.custom.transport.selected_notification_transport = 'whatsapp';
      initialValues.custom.transport.phone =
        copyTicketDto.shipper_data.notification_transports[0].phone_number;
    }
    if (copyTicketDto.shipper_data.notification_transports[0].transport === 'email') {
      initialValues.custom.transport.selected_notification_transport = 'email';
      initialValues.custom.transport.email =
        copyTicketDto.shipper_data.notification_transports[0].email;
    }
  }
  // fill order_data
  //   loads
  initialValues.order_data.loads_data = copyTicketDto.order_data.loads_data;
  initialValues.order_data.loads_data.loads = copyTicketDto.order_data.loads_data.loads.map((l) => {
    return {
      ...l,
      item_length: convertNullToEmptyString(l.item_length) || '',
      item_height: convertNullToEmptyString(l.item_height) || '',
      item_width: convertNullToEmptyString(l.item_width) || '',
    };
  });
  initialValues.order_data.loads_data.totals = {
    cubic_meters: convertNullToEmptyString(copyTicketDto.order_data.loads_data.cubic_meters) || '',
    linear_meters:
      convertNullToEmptyString(copyTicketDto.order_data.loads_data.linear_meters) || '',
    total_weight: convertNullToEmptyString(copyTicketDto.order_data.loads_data.total_weight) || '',
  };
  // pickup
  initialValues.order_data.pickup = copyTicketDto.order_data.pickup;
  initialValues.order_data.pickup.time_from = cleanTimeFromBackend(
    copyTicketDto.order_data.pickup.time_from
  );
  initialValues.order_data.pickup.time_to = cleanTimeFromBackend(
    copyTicketDto.order_data.pickup.time_to
  );
  //  dropoff
  initialValues.order_data.dropoff = copyTicketDto.order_data.dropoff;
  initialValues.order_data.dropoff.time_from = cleanTimeFromBackend(
    copyTicketDto.order_data.dropoff.time_from
  );
  initialValues.order_data.dropoff.time_to = cleanTimeFromBackend(
    copyTicketDto.order_data.dropoff.time_to
  ); // service_type
  initialValues.order_data.service_type = copyTicketDto.order_data.service_type;
  // complementary

  const [additionalServices, otherAdditionalServices] = splitAdditionalServices(
    copyTicketDto.order_data.complementary_info.additional_services
  );

  initialValues.order_data.complementary_info.additional_services = additionalServices;
  initialValues.order_data.complementary_info.other_additional_services = otherAdditionalServices;
  initialValues.order_data.complementary_info.customer_internal_reference =
    copyTicketDto.order_data.complementary_info.customer_internal_reference;

  const deadline = copyTicketDto.order_data.complementary_info.customer_deadline;
  const separatedDeadline = getSeparateDateAndTimeFromDatetime({ dateTime: deadline });
  initialValues.order_data.complementary_info.customer_deadline_date = separatedDeadline.date;
  initialValues.order_data.complementary_info.customer_deadline_time = separatedDeadline.time;

  const existingShiperId = copyTicketDto?.shipper?.id || '';
  initialValues.shipper_id = existingShiperId;
  return initialValues;
};

const getUpdateTicketDetailDto = ({ originalTicketDto, newTicketDto }) => {
  const originalFields =
    ticketService.dataTransformation.getUpdateableFieldsFromTicketObject(originalTicketDto);
  const newFields =
    ticketService.dataTransformation.getUpdateableFieldsFromTicketObject(newTicketDto);
  const updatedFields = diff(originalFields, newFields);
  if (updatedFields?.order_data?.complementary_info?.additional_services) {
    updatedFields.order_data.complementary_info.additional_services =
      newTicketDto.order_data.complementary_info.additional_services;
  }
  if (!!updatedFields?.shipper_data?.notification_transports) {
    updatedFields.shipper_data.notification_transports =
      newTicketDto.shipper_data.notification_transports;
  }
  if (!!updatedFields?.order_data?.service_type?.vehicle_details) {
    updatedFields.order_data.service_type.vehicle_details =
      newTicketDto.order_data.service_type.vehicle_details;
  }
  if (!!updatedFields?.order_data?.loads_data?.loads) {
    updatedFields.order_data.loads_data.loads = newTicketDto.order_data.loads_data.loads;
  }
  const updateTicketDetailDto = updatedFields;
  return updateTicketDetailDto;
};

const getUpdateableFieldsFromTicketObject = (ticketObject) => {
  return {
    shipper_id: ticketObject.shipper_id,
    shipper_data: {
      company_name: ticketObject.shipper_data.company_name,
      company_id: ticketObject.shipper_data.company_id,
      contact_name: ticketObject.shipper_data.contact_name,
      phone: ticketObject.shipper_data.phone,
      notification_transports: ticketObject.shipper_data.notification_transports,
    },
    order_data: {
      pickup: {
        company_name: ticketObject.order_data.pickup.company_name,
        country: ticketObject.order_data.pickup.country,
        city: ticketObject.order_data.pickup.city,
        address: ticketObject.order_data.pickup.address,
        //
        date: ticketObject.order_data.pickup.date,
        time_from: ticketObject.order_data.pickup.time_from,
        time_to: ticketObject.order_data.pickup.time_to,
        //
        zipcode: ticketObject.order_data.pickup.zipcode,
        observations: ticketObject.order_data.pickup.observations,
      },
      dropoff: {
        company_name: ticketObject.order_data.dropoff.company_name,
        country: ticketObject.order_data.dropoff.country,
        city: ticketObject.order_data.dropoff.city,
        address: ticketObject.order_data.dropoff.address,
        //
        date: ticketObject.order_data.dropoff.date,
        time_from: ticketObject.order_data.dropoff.time_from,
        time_to: ticketObject.order_data.dropoff.time_to,
        //
        zipcode: ticketObject.order_data.dropoff.zipcode,
        observations: ticketObject.order_data.dropoff.observations,
      },
      //   loads
      service_type: {
        vehicle_type: ticketObject.order_data.service_type.vehicle_type,
        vehicle_details: ticketObject.order_data.service_type.vehicle_details,
      },
      loads_data: ticketObject.order_data.loads_data,
      complementary_info: {
        customer_deadline: ticketObject.order_data.complementary_info.customer_deadline,
        customer_internal_reference:
          ticketObject.order_data.complementary_info.customer_internal_reference,
        additional_services: ticketObject.order_data.complementary_info.additional_services,
      },
    },
  };
};

const dataTransformation = {
  getTicketDtoFromFormValues,
  getInitialFormValuesFromTicketDto,
  getUpdateableFieldsFromTicketObject,
  getUpdateTicketDetailDto,
};

//
//
//
//
//
//
// callBackend
//
//
//
//
//
//
//

// calls api to create a new Ticket
const createNewTicket = async ({ ticketDto }) => {
  return createNewTicketAPICall({ ticketDto });
};

// calls api to get ticketDetail
const getTicketDetail = async ({ id }) => {
  return getTicketDetailApiCall({ id });
};

// calls api to update ticketDetail
const updateTicketDetail = async ({ id, updateTicketDetailDto }) => {
  return updateTicketDetailApiCall({ id, updateTicketDetailDto });
};

// calls api to cancel a Ticket
const cancelTicket = async ({ id, feedBackDTO }) => {
  return cancelTicketApiCall({ id, feedBackDTO });
};

// calls api to move a Ticket to TMS
const moveTicketToTMS = async ({ id, orderIdDTO }) => {
  return moveTicketToTMSApiCall({ id, orderIdDTO });
};

const launchOffer = async ({ routeId, dto }) => {
  return launchOfferApiCall({ routeId, dto });
};
const finishCostNegotiation = async ({ ticketId, quoteId }) => {
  return finishCostNegotiationApiCall({ ticketId, quoteId });
};
const closeAuctions = async ({ routeId }) => {
  return closeAuctionsApiCall({ routeId });
};
const addBid = async ({ addBidDto, auctionId }) => {
  return addBidApiCall({ addBidDto, auctionId });
};

const createComment = async ({ ticketId, body }) => {
  return createCommentApiCall({ ticketId, body });
};

const sendTicketUpdate = async ({ id, dto }) => sendTicketUpdateApiCall({ id, dto });

const callBackend = {
  createNewTicket,
  getTicketDetail,
  updateTicketDetail,
  cancelTicket,
  moveTicketToTMS,
  sendTicketUpdate,
  launchOffer,
  finishCostNegotiation,
  closeAuctions,
  addBid,
  createComment,
};

//
//
//
//
//
//
// ticketService
//
//
//
//
//
//
//

const ticketService = {
  defaultValues,
  utils,
  bussiness,
  dataTransformation,
  callBackend,
  createComment,
};

export default ticketService;
